module.exports = __webpack_public_path__ + "img/g8.81284f1e.jpg";